import { render } from "./TextSanitized.vue?vue&type=template&id=f5daf550&ts=true"
import script from "./TextSanitized.vue?vue&type=script&lang=ts"
export * from "./TextSanitized.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__